export let VERSION = {
        "version": "1.09.34",
        "release_notes": `- Performance & security improvements
- Dark mode support
- New activities: Feedback + incoming email/SMS
`,
        "release_notes_extended": `MC 3.2.24 features
- 6824: Dark mode support (3.2.24)
- 6836: Angular 21 upgrade (3.2.24)
- 6835: Capacitor 8 upgrade (3.2.24)
- 6834: Feedback + incoming email/SMS activities (3.2.24)
- 6844: Content Security Policy (CSP) implementation (3.2.24)
- 6841: Vehicle export text wildcards/library (3.2.24)
- 6842: Sale special conditions (3.2.24)
- 6893: OTP requirement for email/mobile changes (3.2.24)

MC 3.2.23 features
- 6628: Convert any activity type to any other type (3.2.23)
- 6575: Quick notes and quick email (3.2.23)
`
      };
